import React, { useCallback } from 'react'

import Step from '../../../../../../../features/components/Forms/StepForm/Step'
import RadioBlock from '../../../../../../../components/Form/RadioBlock'
import InventoryOverviewSpoiler from '../../../components/InventoryOverviewSpoiler'

import { ENVIRONMENT_TYPE, lineItemEnvironmentTypeLabels, environmentTypes } from '../../fields'

const stepFields = [ENVIRONMENT_TYPE]

const LineItemTypeStep = ({ formik, handleStepChange }) => {
  const { setFieldValue, values } = formik

  const handleContinue = useCallback(() => {
    handleStepChange(stepFields)
  }, [handleStepChange])

  return (
    <Step stepTitle="What type of line item do you want to create?" handleContinue={handleContinue}>
      <InventoryOverviewSpoiler initialOpen={true} />
      <RadioBlock
        setFieldValue={setFieldValue}
        id="radio_video_line_item"
        name={ENVIRONMENT_TYPE}
        label={lineItemEnvironmentTypeLabels[environmentTypes.VIDEO_PLAYER]}
        value={environmentTypes.VIDEO_PLAYER}
        selectedValue={values[ENVIRONMENT_TYPE]}
      />
      <RadioBlock
        setFieldValue={setFieldValue}
        id="radio_display_line_item"
        name={ENVIRONMENT_TYPE}
        label={lineItemEnvironmentTypeLabels[environmentTypes.BROWSER]}
        value={environmentTypes.BROWSER}
        selectedValue={values[ENVIRONMENT_TYPE]}
      />
    </Step>
  )
}

export default LineItemTypeStep
